import { type Country, siteNames } from '@seek/melways-sites';

import { accountCountries, type AccountCountry } from 'src/constants/taxonomy';
import { getCountryFromSite } from 'src/siteConfig';
import type { Advertiser, EmployerSiteName } from 'src/types';

const accountCountryToMelwaysCountryMapping: Omit<
  Record<AccountCountry, Country>,
  'Other'
> = {
  Australia: getCountryFromSite(siteNames.employer.seek.au),
  'New Zealand': getCountryFromSite(siteNames.employer.seek.nz),
  Singapore: getCountryFromSite(siteNames.employer.seek.sg),
  Indonesia: getCountryFromSite(siteNames.employer.seek.id),
  Malaysia: getCountryFromSite(siteNames.employer.seek.my),
  Philippines: getCountryFromSite(siteNames.employer.seek.ph),
  'Hong Kong': getCountryFromSite(siteNames.employer.seek.hk),
  Thailand: getCountryFromSite(siteNames.employer.seek.th),
};

/**
 * @function isAccountCrossSite
 * An Account is cross-site if it's from a peer's site
 */
export type AdvertiserWithCountryOnly = Pick<Advertiser, 'country'>;

export default function isAccountCrossSite({
  account,
  site,
  isLocalEnvironment,
}: {
  account: AdvertiserWithCountryOnly;
  site: EmployerSiteName;
  isLocalEnvironment: boolean;
}) {
  if (isLocalEnvironment) {
    return false;
  }
  if (account.country === accountCountries.OTHER) {
    return false;
  }
  const siteCountry = getCountryFromSite(site);

  const accountCountry =
    accountCountryToMelwaysCountryMapping[account.country] || siteCountry; // fallback to equal siteCountry if no mapping of 8 countries supported.

  return siteCountry !== accountCountry;
}
